'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:TodaysAssignmentsController
 * @description
 * # TodaysAssignmentsController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('TodaysAssignmentsController', ['$scope', '$rootScope', '$location', 'TALocationService', 'TodaysAssignments', 'Constants',
      function ($scope, $rootScope, $location, TALocationService, TodaysAssignments, Constants) {

      $scope.todaysAssignments = new TodaysAssignments($scope, Constants.TodaysAssignments.Levels.HomePage);

      $scope.openPreparationList = function () {
          $scope.todaysAssignments.dataLoaded = false;
          TALocationService.GoToThePreparationList();
      };

      $scope.roomDetails = function (facilityId, roomId) {
          $scope.todaysAssignments.dataLoaded = false;
          TALocationService.GoToTheRoomGroups(facilityId, roomId);
      };

      $scope.openActivity = function (activity) {
          $scope.todaysAssignments.dataLoaded = false;
          TALocationService.GoToTheActivityDetails(activity.scheduleId);
      };

      $scope.back = function () {
          $location.path('/home');
      };

      function init() {
          $scope.todaysAssignments.LoadAssignmentsData();
          $rootScope.todaysAssignmentsTitle = 'Today\'s Assignments';
          $rootScope.scheduleDate = moment();
      }

      init();

      $scope.$on('$destroy', function () {
          $scope.todaysAssignments.closeSignalRConnection();
      });

  }]);
